import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";

export default function TrustInsuranceLicenses() {

    return (
        <main className='main'>

            <IntroSection
                title="Trust & Insurance Licenses"
                subtitle="Build Trust Companies & Insurance Entities with Offshore Advisory"
                description="We assist <b>financial groups</b>, <b>wealth managers</b>, and <b>investors</b> in obtaining <b>Trust & Fiduciary Licenses</b> as well as <b>Insurance & Reinsurance Licenses</b> across <b>multiple jurisdictions</b>. These licenses enable you to operate as a <b>regulated financial services provider</b>, offering <b>fiduciary management</b>, <b>asset protection</b>, <b>insurance underwriting</b>, and <b>captive solutions</b>."
                badges={
                    [
                        "Trust & Fiduciary Licenses",
                        "Insurance & Reinsurance Licenses",
                        "Captive & Niche Insurance Providers"
                    ]
                }
                buttonText="Request a Proposal"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/trust-insurance-licenses-hero.jpg")}
                imageAlt=""
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Obtain a Trust or Insurance License?'
                        blocks={
                            [
                                {
                                    subtitle: "Trust License Benefits",
                                    items:
                                        [
                                            {
                                                text: "Manage client assets and estates legally."
                                            },
                                            {
                                                text: "Provide fiduciary, trustee, and custodial services."
                                            },
                                            {
                                                text: "Operate family offices, wealth management firms, and fiduciary groups."
                                            },
                                            {
                                                text: "Build credibility for cross-border tax and succession planning."
                                            }
                                        ]
                                },
                                {
                                    subtitle: "Insurance License Benefits",
                                    items:
                                        [
                                            {
                                                text: "Underwrite insurance policies legally."
                                            },
                                            {
                                                text: "Launch captives for corporate risk management."
                                            },
                                            {
                                                text: "Operate reinsurance businesses globally."
                                            },
                                            {
                                                text: "Offer niche coverage (crypto, fintech, high-risk industries)."
                                            }
                                        ]
                                },

                            ]
                        }
                    />

                    <InfoBlocks
                        title="Jurisdictions We Cover"
                        subtitle='Trust & Fiduciary Licenses'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Western Sahara (CRA)",
                                                text: "Trust License Type A/B"
                                            },
                                            {
                                                title: "Mwali (Comoros)",
                                                text: "International trust company setups"
                                            },
                                            {
                                                title: "Anjouan (Comoros)",
                                                text: "Flexible fiduciary licensing"
                                            },
                                            {
                                                title: "Nevis & Belize",
                                                text: "Strong trust laws, asset protection hubs"
                                            },
                                            {
                                                title: "Mauritius",
                                                text: "Private trust companies & fiduciary providers"
                                            },
                                            {
                                                title: "Cayman Islands / BVI",
                                                text: "Premier global fiduciary jurisdictions"
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <LocationTimeline
                        title="Insurance & Reinsurance Licenses"
                        subtitle=''
                        item={
                            [
                                {
                                    title: "Western Sahara (CRA)",
                                    text: "Insurance & Reinsurance Licenses"
                                },
                                {
                                    title: "Mwali (Comoros)",
                                    text: "Captive insurance structures"
                                },
                                {
                                    title: "Belize",
                                    text: "International insurance companies"
                                },
                                {
                                    title: "Mauritius",
                                    text: "Insurance & reinsurance framework recognized in Africa & Asia"
                                },
                                {
                                    title: "Vanuatu",
                                    text: "Offshore insurance licensing"
                                },
                                {
                                    title: "Cayman Islands / Bermuda",
                                    text: "World leaders in captives & reinsurance"
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Our Services Include'
                        services={
                            [
                                {
                                    title: "company-formation & Incorporation",
                                    text: ""
                                },
                                {
                                    title: "License Application Drafting & Filing",
                                    text: ""
                                },
                                {
                                    title: "AML/KYC Compliance Framework",
                                    text: ""
                                },
                                {
                                    title: "Business Plan & Risk Management Preparation",
                                    text: ""
                                },
                                {
                                    title: "Banking & Custodial Account Setup",
                                    text: ""
                                },
                                {
                                    title: "Nominee Directors, Compliance Officers & MLROs",
                                    text: ""
                                },
                                {
                                    title: "Ongoing Reporting & Regulatory Maintenance",
                                    text: ""
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Offshore (Western Sahara, Mwali, Anjouan)",
                                    duration: "6–10 weeks",
                                },
                                {
                                    name: "Mid-Tier (Belize, Mauritius, Vanuatu)",
                                    description: "2–4 months"
                                },
                                {
                                    name: "Premium (Cayman, Bermuda)",
                                    description: "6–12 months"
                                },
                                {
                                    name: "Offshore licenses",
                                    description: "USD 7,000 – 40,000"
                                },
                                {
                                    name: "Mid-tier licenses",
                                    description: "USD 50,000 – 80,000"
                                },
                                {
                                    name: "MidPremium jurisdictions",
                                    description: "USD 100,000+ (with high capital requirements)"
                                },

                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Ready to establish your own Trust or Insurance company?"
                        description="From offshore trust licenses to captive insurance solutions, Offshore Advisory provides end-to-end licensing support."
                        buttonText="Book a Trust & Insurance Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};
const faqData = [
    {
        question: "What is a Trust License?",
        content: [
            { type: "answer", text: "It allows companies to legally manage and hold assets on behalf of clients (fiduciary services)." },
        ],
    },
    {
        question: "What is a Captive Insurance License?",
        content: [
            { type: "answer", text: "A license allowing a company to underwrite insurance for itself or related entities, reducing costs and improving risk management." },
        ],
    },
    {
        question: "Which jurisdiction is best for trust companies?",
        content: [
            { type: "answer", text: "Western Sahara and Mwali are cost-effective; Cayman and BVI are globally prestigious." },
        ],
    },
    {
        question: "Do I need high capital for insurance licenses?",
        content: [
            { type: "answer", text: "Capital requirements vary — from low offshore (USD 100k–250k) to high-tier (USD 1M+)." },
        ],
    },
    {
        question: "Can one license cover both trust & insurance?",
        content: [
            { type: "answer", text: "Yes, in Western Sahara, a single entity can apply for Trust + Insurance licensing under CRA." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We launched a trust and fiduciary company in Mwali with Offshore Advisory’s support. Their team simplified everything.",
            author: "Elena P.",
            role: "Fiduciary Director"
        },
        {
            quote: "Offshore Advisory helped us obtain a captive insurance license in Mauritius, allowing us to insure our group’s risks globally.",
            author: "Michael R.",
            role: "Corporate CFO"
        }
    ]
;
